


import React, { useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from "@material-ui/core/Grid";
import Box from '@material-ui/core/Box';
import Clients from './Clients'
import Assignments from './Assignments'
import Finance from './Finance'
import DataService from '../../../../../Service';
import HeaderMenu from '../../../../../Components/HeaderMenu';
import { useLocation } from 'react-router';
import Loader from "../../../../../Components/Loader";

const useStyles = makeStyles((theme) => ({
    tabRoot: {
        borderWidth: 0,
        borderBottomWidth: 1,
        borderStyle: "solid",
        borderColor: "#ddd",
        position: "sticky",
        zIndex: "101",
        backgroundColor: "white",
        marginTop: "5px",
        boxShadow: "0px 0px 0px 10px #fff",
        '& .MuiTabs-flexContainer': {
            justifyContent: "flex-start",

        },
        '& .MuiTabs-indicator': {
            backgroundColor: "transparent"
        }
    },
    tabs: {
        color: "#1e1e1e",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "#ddd",
        backgroundColor: "rgba(7,127,131,.75)",
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        marginRight: 10,
        fontSize: 14,
        minWidth: 130,
        textTransform: "capitalize",
        "&:hover,&.Mui-selected": {

            color: "#fff",
            backgroundColor: "rgba(7,127,131,1)",
            opacity: 1
        }
    }

}));
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <Box role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
            {value === index && children}
        </Box>
    );
}

export default function AdminDashboard(props) {
    console.log("isManageInfo", props.isManageInfo)
    const classes = useStyles();
    const { pathname } = useLocation()
    const [value, setValue] = React.useState(0);
    const [action, setAction] = React.useState("");
    const [loader, setLoader] = React.useState(true);
    const tabArr = ["Clients", "Assignments", "Finance"]
    const tabPanelArr = [<Clients isManageInfo={props.isManageInfo} setLoader={setLoader} />, <Assignments isManageInfo={props.isManageInfo} setLoader={setLoader} />, <Finance isManageInfo={props.isManageInfo} setLoader={setLoader} />]

    const handleChange = (event, newValue) => {
        setLoader(true)
        setValue(newValue);
    };

    const handleClose = (event, newValue) => {
        setAction("");
    };

    useEffect(() => {
        // getData();
    }, []);


    const getData = () => {

        DataService.getData({}, "dashboards/fetch_clients_data")
            .then((response) => {
                console.log(`response`, response)

            })
            .catch((err) => { });
    };

    return <>
        {pathname === "/admin/dashboard" && <HeaderMenu />}
        {loader && <Loader />}

        <Grid container direction="row" justify="center" alignItems="center" >
            <Grid item xs={10} style={{ position: "relative" }}>
                <Box >
                    <Tabs value={value} onChange={handleChange} style={pathname === "/admin/dashboard" ? { top: "74px" } : { top: "120px" }} classes={{ root: classes.tabRoot }}>
                        {
                            tabArr.map((option) => <Tab classes={{ root: classes.tabs }} label={option} />)
                        }
                    </Tabs>
                    {
                        tabPanelArr.map((option, index) => <TabPanel value={value} index={index}>{option}</TabPanel>)
                    }
                </Box>
            </Grid>
        </Grid>
    </>



}



